import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import EditPopularLocationManagement from '../../../components/siteadmin/EditPopularLocation/EditPopularLocationManagement';

// Query
import editPopularLocationQuery from './editPopularLocationQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './EditPopularLocation.css';

const EditPopularLocation = (props) => {

    const { data: { loading, editPopularLocation }, title } = props;
    const popularLocationData = editPopularLocation ? {
        ...editPopularLocation,
        dynamicPopularLocation: editPopularLocation?.dynamicPopularLocation?.length > 0 ? editPopularLocation.dynamicPopularLocation : [{
            language: 'en',
            location: editPopularLocation?.location
        }]
    } : {};

    return (
        <>
            {
                !loading && <EditPopularLocationManagement
                    title={title} initialValues={popularLocationData}
                />
            }
        </>
    );
}

EditPopularLocation.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
        loading: PropTypes.bool,
    }),
    locationId: PropTypes.number.isRequired
};

EditPopularLocation.defaultProps = {
    data: {
        loading: true
    }
};

export default compose(
    withStyles(s),
    withQuery(editPopularLocationQuery,
        {
            options: (props) => ({
                variables: {
                    id: props.locationId,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        })
)(EditPopularLocation);
